import React, { useRef } from 'react';
import { Button } from '@mui/material';
import { PricingResponse } from '../../api/Requests';

type BillingPeriod = 'monthly' | 'annual';

interface SubscribeButtonProps {
  pricingInfo: PricingResponse;
  billingPeriod: BillingPeriod;
  authToken: string | null | undefined;
  onUpgradeClick: () => void;
}

export function SubscribeButton({ 
  pricingInfo, 
  billingPeriod, 
  authToken, 
  onUpgradeClick 
}: SubscribeButtonProps) {
  const formRef = useRef<HTMLFormElement>(null);
  const selectedPrice = billingPeriod === 'annual' && pricingInfo.prices.annual
    ? pricingInfo.prices.annual 
    : pricingInfo.prices.monthly;

  return (
    <form action="api/create-checkout-session" method="POST" ref={formRef}>
      <input type="hidden" name="price_id" value={selectedPrice.id} />
      <input type="hidden" name="jwt" value={authToken || ''} />
      <input type="hidden" name="return_url" value={window.location.href} />
      <Button 
        variant="contained" 
        fullWidth
        size="large" 
        color="secondary" 
        type="submit" 
        onClick={onUpgradeClick}
      >
        Subscribe Now
      </Button>
    </form>
  );
}

